/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect, Fragment} from 'react'
import {useIntl} from 'react-intl'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import {Col, Modal, Row, Spinner} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import {useNavigate} from 'react-router-dom'
import JobServices from '../../../../services/job'
import useServices from '../../../../utils/hooks/useServices'
import useDebounce from '../../../../utils/hooks/useDebounce'
import 'react-quill/dist/quill.snow.css'
import HTMLRenderer from 'react-html-renderer'
import FormGenerator from 'utils/helpers/FormGenerator'
import Contains from 'utils/helpers/Contains'
import MasterServices from '../../../../services/master'

type Props = {
  company: any
}

const Card: React.FC<Props> = ({company}) => {
  let navigate = useNavigate()
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })
  const [showFilter, setShowFilter] = useState(false)
  const [query, setQuery] = useState<any>({
    q: '',
    sort_order: 'desc',
    sort_field: 'company_jobs_id',
  })

  const [submit, setSubmit] = useState(false)
  const [filter, setFilter] = useState<any>({})
  const [jobs, loadingJobs, makeJobsEmpty, refreshJobs] = useServices(
    JobServices.getJobHash,
    {
      ...query,
      page: pagination.page,
      per_page: pagination.per_page,
      status: [1],
      city_id: filter?.city_id,
      skill_id: filter?.skill_id,
      industry_id: filter?.industry_id,
      min_salary: filter?.min_salary,
      max_salary: filter?.max_salary,
      working_type_id: filter?.working_type_id,
      job_level: filter?.job_level,
      is_remote: filter?.is_remote,
      company_id: filter?.company_id,
    },
    []
  )
  const [formValue, setFormValue] = useState<any>({})
  const [inputs, setInputs] = useState([
    {
      name: 'city_id',
      label: 'Lokasi',
      type: 'select2',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'cities_name',
      getItemValueId: 'cities_id',
    },
    {
      name: 'skill_id',
      label: 'Keahlian   ',
      type: 'select2',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'skills_name',
      getItemValueId: 'skills_id',
    },
    {
      name: 'industry_id',
      label: 'Industri',
      type: 'select2',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'industries_name',
      getItemValueId: 'industries_id',
    },
    {
      name: 'salary',
      label: 'Gaji',
      type: 'select2',
      validation: {},
      mb: 'mb-8',
      col: 6,
      options: [
        {
          name: 'Rp 4.000.000 - Rp 6.000.000',
          value: 'Rp 4.000.000 - Rp 6.000.000',
        },
        {
          name: 'Rp 7.000.000 - Rp 10.000.000',
          value: 'Rp 7.000.000 - Rp 10.000.000',
        },
        {
          name: 'Rp 10.000.000 - Rp 15.000.000',
          value: 'Rp 10.000.000 - Rp 15.000.000',
        },
        {
          name: 'Rp 15.000.000 - Rp 25.000.000',
          value: 'Rp 15.000.000 - Rp 25.000.000',
        },
        {
          name: 'Rp 25.000.000 - Rp 30.000.000',
          value: 'Rp 25.000.000 - Rp 30.000.000',
        },
        {
          name: 'Rp 30.000.000 - Rp 50.000.000',
          value: 'Rp 30.000.000 - Rp 50.000.000',
        },
        {
          name: 'Rp 50.000.000 - Rp 70.000.000',
          value: 'Rp 50.000.000 - Rp 70.000.000',
        },
        {
          name: '> Rp 70.000.000',
          value: '> Rp 70.000.000',
        },
      ],
      additional: '',
      getItemValue: 'name',
      getItemValueId: 'value',
    },
    {
      name: 'working_type_id',
      label: 'Tipe Pekerjaan',
      type: 'select2',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'working_types_name',
      getItemValueId: 'working_types_id',
    },

    {
      name: 'job_level_id',
      label: 'Level Pekerjaan',
      type: 'select2',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'job_levels_name',
      getItemValueId: 'job_levels_id',
    },
    {
      name: 'is_remote',
      label: 'Dapat Dikerjakan Remote',
      type: 'select2',
      validation: {},
      col: 6,
      options: [
        {
          name: 'Ya',
          value: '1',
        },
        {
          name: 'Tidak',
          value: '0',
        },
      ],
      additional: '',
      getItemValue: 'name',
      getItemValueId: 'value',
    },
  ])

  useEffect(() => {
    refreshJobs()
    generateTotalPage(pagination.total_page)
  }, [pagination.per_page, pagination.page])

  useEffect(() => {
    if (company?.companies_id) {
      setFilter({
        ...filter,
        company_id: [company?.companies_id],
      })
    }
  }, [company])

  useEffect(() => {
    refreshJobs()
    generateTotalPage(pagination.total_page)
    setShowFilter(false)
  }, [filter])

  useEffect(() => {
    fetchCity()
    fetchSkill()
    fetchIndustry()
    fetchWorkingType()
    fetchJobLevel()
  }, [])

  const onKeyUp = (input: any, value: any, key: any) => {
    const name = input
    switch (name) {
      case 'city_id':
        fetchCity(value)
        break
      case 'skill_id':
        fetchSkill(value)
        break
      case 'industry_id':
        fetchIndustry(value)
        break
      case 'working_type_id':
        fetchWorkingType(value)
        break
      case 'job_level_id':
        fetchJobLevel(value)
        break
    }
  }

  const fetchCity = async (q = '') => {
    await MasterServices.getCity({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[0].options = data
        setInputs(inputs)
      })
      .catch((err) => {
      })
  }

  const fetchSkill = async (q = '') => {
    await MasterServices.getSkill({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[1].options = data
        setInputs(inputs)
      })
      .catch((err) => {
      })
  }

  const fetchIndustry = async (q = '') => {
    await MasterServices.getIndustry({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[2].options = data
        setInputs(inputs)
      })
      .catch((err) => {
      })
  }

  const fetchWorkingType = async (q = '') => {
    await MasterServices.getWorkingType({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[4].options = data
        setInputs(inputs)
      })
      .catch((err) => {
      })
  }

  const fetchJobLevel = async (q = '') => {
    await MasterServices.getJobLevel({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[5].options = data
        setInputs(inputs)
      })
      .catch((err) => {
      })
  }

  const handleFilter = () => {
    let salary: any = [null, null]
    if (formValue.salary?.value) {
      salary = formValue?.salary?.value
        ?.toString()
        ?.split('Rp')
        ?.join()
        ?.split(' ')
        ?.join()
        ?.replaceAll(',', '')
        ?.replaceAll('.', '')
        ?.replaceAll('>', '')
        ?.split('-')
    }

    setFilter({
      city_id: formValue?.city_id?.cities_id ? [formValue?.city_id?.cities_id] : [],
      skill_id: formValue?.skill_id?.skills_id ? [formValue?.skill_id?.skills_id] : [],
      industry_id: formValue?.industry_id?.industries_id
        ? [formValue?.industry_id?.industries_id]
        : [],
      min_salary: salary[0],
      max_salary: salary[1],
      working_type_id: formValue?.working_type_id?.working_types_id
        ? [formValue?.working_type_id?.working_types_id]
        : [],
      job_level: formValue?.job_level?.job_levels_id ? [formValue?.job_level?.job_levels_id] : [],
      is_remote: formValue?.is_remote?.value,
      company_id: [company?.companies_id],
    })
  }

  const handleReset = () => {
    setFormValue({})
  }

  const generateTotalPage = (totalPage: number) => {
    let total = 0
    let newTotal: any = []

    for (total = 0; total < totalPage; total++) {
      newTotal.push(total + 1)
    }

    return newTotal
  }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  const toggleFilter = () => setShowFilter(!showFilter)

  const onChange = (e: any) => {
    setFormValue({
      ...formValue,
      [e.target.name]: e.target.value,
    })
  }

  return (
    <>
      <div className='row'>
        <Modal show={showFilter} onHide={submit ? () => null : toggleFilter} size='lg'>
          <Modal.Header closeButton>
            <Modal.Title> Filter</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>{FormGenerator(inputs, formValue, onChange, onKeyUp)}</Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={() => handleReset()}>
              Reset
            </Button>
            <Button onClick={() => handleFilter()}>Simpan</Button>
          </Modal.Footer>
        </Modal>
        <div className='col-md-12'>
          <div className='card-custom mb-8'>
            <Row>
              <Col md={{span: 4}}>
                <Form.Control
                  placeholder='Cari...'
                  name='q'
                  onChange={(e) => setQuery({...query, q: e.target.value})}
                />
              </Col>
              <Col md={{span: 2, offset: 4}}>
                <Button type='button' onClick={toggleFilter} className='form-control'>
                  Filter
                </Button>
              </Col>
              <Col md={{span: 2}}>
                <Form.Select
                  aria-label='Default select example'
                  className='mr-8'
                  onChange={(e) => {
                    setQuery({...query, sort_order: e.target.value})
                  }}
                >
                  <option value='desc'>Terbaru</option>
                  <option value='asc'>Terlama</option>
                </Form.Select>
              </Col>
            </Row>
          </div>
          <div style={{marginLeft: '40%'}}>
            {loadingJobs && (
              <Spinner animation='border' role='status' style={{height: '100px', width: '100px'}} />
            )}
            {jobs.data?.data?.length === 0 && !loadingJobs && <h5>Tidak ada Data</h5>}
          </div>
          <Row>
            {jobs?.data?.data?.map((item: any, key: number) => (
              <Col md={6} key={key}>
                <div
                  className='card-custom mb-8'
                  onClick={() =>
                    navigate(
                      '/job-search/' +
                        item.company_jobs_id +
                        `?companyId=${item.company?.companies_id}`
                    )
                  }
                  style={{
                    cursor: 'pointer',
                  }}
                >
                  <Row>
                    <Col md={0}></Col>
                    <Col md={12}>
                      <h5
                        style={{color: '#FF6C06', cursor: 'pointer'}}
                        onClick={() => navigate('/job-search/' + item.company_jobs_id)}
                      >
                        {item.company_jobs_title}
                      </h5>
                      <span>{item.company?.companies_name}</span>
                      <br />
                      <br />
                    </Col>
                    <div style={{height: '160px'}} className='mt-4'>
                      <h6>Deskripsi</h6>
                      <HTMLRenderer
                        html={`${item.company_jobs_description.substring(0, 250)} ${
                          item.company_jobs_description?.length > 250 ? '...' : ''
                        }`}
                      />
                    </div>
                  </Row>
                  <Row>
                    <hr />
                    <Col md={4}>
                      <img src={require('../../../../assets/icons/job-field.png')} />
                      <span style={{textTransform: 'capitalize'}}>
                        {'   '}
                        {item.degree?.degrees_name}
                      </span>
                    </Col>
                    <Col md={4}>
                      <img src={require('../../../../assets/icons/time.png')} />
                      <span>
                        {'  '}
                        {new Date(item.created_at).toDateString()}
                      </span>
                    </Col>
                  </Row>
                </div>
              </Col>
            ))}
          </Row>
          {jobs?.data?.data?.length > 0 && (
            <Fragment>
              <div>
                <span>
                  Menampilkan {jobs?.data?.from} - {jobs?.data?.to} dari {jobs?.data?.total}
                </span>
              </div>
              <div style={{float: 'right'}}>
                <Pagination>
                  {generateTotalPage(jobs?.data?.last_page)?.map((item: any) => {
                    return (
                      <Pagination.Item
                        key={item}
                        active={item === pagination.page}
                        onClick={() => {
                          makeJobsEmpty()
                          onChangePerPage(pagination.per_page, item)
                        }}
                      >
                        {item}
                      </Pagination.Item>
                    )
                  })}
                </Pagination>
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </>
  )
}

const JobList: React.FC<Props> = ({company}) => {
  return (
    <>
      {Contains('company Company', [localStorage.getItem('role')]) && (
        <PageTitle
          breadcrumbs={[
            {
              title: 'Dashboard',
              path: '/dashboard',
              isSeparator: false,
              isActive: false,
            },
            {
              title: '/',
              path: '',
              isSeparator: false,
              isActive: false,
            },
          ]}
        >
          Lowongan Pekerjaan
        </PageTitle>
      )}
      <Card company={company} />
    </>
  )
}

export default JobList
